import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "list", "hiddenField"];

  static values = {
    disabled: Boolean
  }

  connect() {
    this.keywords = this.hiddenFieldTarget.value ? JSON.parse(this.hiddenFieldTarget.value) : [];
    this.updateKeywords();
  }

    addKeyword() {
      if (this.inputTarget.value.trim() !== "") {
        const keyword = this.inputTarget.value.trim();

        if (!this.keywords.includes(keyword)) {
          this.keywords.push(keyword);
          this.updateKeywords();
        }

        this.inputTarget.value = "";
      }
    }

    updateKeywords() {
      this.listTarget.innerHTML = this.keywords
        .map((keyword, index) => {
          const keywordSpan = document.createElement('span');
          keywordSpan.textContent = keyword;

          return `
            <span class="tag">
              ${keywordSpan.outerHTML}
              ${this.disabledValue ? '' : `<a href="#" class="btn-close" data-action="click->input-tags#removeKeyword" data-keyword-index="${index}"></a>`}
            </span>
          `;
        })
        .join("");

      this.hiddenFieldTarget.value = JSON.stringify(this.keywords);
    }

    removeKeyword(event) {
      event.preventDefault();
      const index = event.currentTarget.dataset.keywordIndex;
      if (index !== undefined) {
        this.keywords.splice(index, 1);
        this.updateKeywords();
      }
    }
}
